import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DynamicTable from "../../components/DynamicTable";
//cookies
import {get_cookies} from "../../components/Cookies/Cookies";
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));



const CashVoucherApproval = () => {
	const refDataFilter = React.createRef();
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		onFetchedApi();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const onFetchedApi = () => {
		refDataFilter.current.onFetchApi();
	  };
	

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "date",
			label: "Date",
		},
		{
			name: "cvno",
			label: "cvno",
		},
		{
			name: "payto",
			label: "Pay To",
		},
		{
			name: "amount",
			label: "Amount",
			options: {
				sort:true,
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "status",
			label: "Status",
		},
		{
			name: "action",
			label: "Action",
			options: {
				sort:false, 
				filter: false, 
				download: false, //exclude this column in csv export
				customBodyRenderLite: (dataIndex) => {
					let cvno =  posts[dataIndex].cvno;
						return (
							<Grid container spacing={1}>
								
                				<Grid item xs={12} lg={12} xl={5}>
								{get_cookies('can_approve') == 1 ?	
									<NavLink to={"/account/cash-voucher-approval-view/"+cvno+"/"+useridNo}>
										<Button variant="contained" color="primary">
											Approve
										</Button>	
									   </NavLink> 
									   	:null}
								</Grid>
								<Grid item xs={12} lg={12} xl={5}>
								{get_cookies('can_approve') == 1 ?	
									<NavLink to={"/account/cash-voucher-approval-view/"+cvno+"/"+useridNo+'/r'}>
										<Button variant="contained" color="primary">
											Reject
										</Button>	
									</NavLink> 
										   	:null}
								
								</Grid>
							
							</Grid>
						);	
					}
				},
		},
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		downloadOptions: {
			filename : 'CashVoucherApproval.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/account">
						<h2 className="header-title">Accounts</h2>
					</NavLink>
					<Typography color="textPrimary">Cash Voucher Approval</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
					<div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={onFetchedApi}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

					<DynamicTable
						title="Cash Voucher Approval"
						columns={columns}
									rows={posts}
						setRows={setPosts}
						ref={refDataFilter}
						dateRange = { dateRange }
						url='get_cvs_for_approval'
          			/>
			</div>
		</div>
	);
};

export default CashVoucherApproval;
